import { Skeleton } from 'antd';
import { useGetManyWarehouses } from 'api/warehouses/use-get-many-warehouses';
import { findWarehouseById } from 'shared/utils/warehouses/find-warehouse-by-id';
import type { IWarehouseNameProps } from './types';

export const WarehouseName: React.FC<IWarehouseNameProps> = (props) => {
  const { warehouseId, prefix = '' } = props;
  const { data: warehouses, isLoading } = useGetManyWarehouses({ withDeprecated: false });
  const warehouseName = findWarehouseById(warehouseId, warehouses)?.name;

  if (isLoading) {
    return <Skeleton.Input size='small' style={{ width: 120 }} />;
  }

  return (
    <span>
      {prefix}
      {warehouseName}
    </span>
  );
};
